import { fillActivityFields } from '@utils'
import cn from 'classnames'
import type { MerchantActivityResponse } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'
import moment from 'moment'
import { getActivityCategory, getCategoryIcon, getCategoryName } from './activityCategories'
import styles from './NotificationsPanel.module.scss'

interface NotificationItemProps {
  activity: MerchantActivityResponse
  onClick: (activity: MerchantActivityResponse) => void
}

export const NotificationItem = ({ activity, onClick }: NotificationItemProps) => {
  const category = getActivityCategory(activity.type)
  const CategoryIcon = getCategoryIcon(category)
  const unread = activity.isRead === false

  const text = fillActivityFields(
    activity,
    tr(`FRONTEND.ACTIVITY.${activity.type}`, (activity.text ?? '').replace(/<.*?>/g, ''))
  )

  return (
    <div
      className={cn(styles['notification-item'], 'notification-item', {
        [styles.unread]: unread,
        unread
      })}
      role='button'
      tabIndex={0}
      onClick={() => onClick(activity)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onClick(activity)
        }
      }}
      data-test={`notification-item-${activity.id}`}
    >
      <span
        className={cn(styles['notification-item-icon'], 'notification-item-icon')}
        role='img'
        aria-label={getCategoryName(category)}
        title={getCategoryName(category)}
      >
        <CategoryIcon />
      </span>
      <div className={cn(styles['notification-item-body'], 'notification-item-body')}>
        <p className={cn(styles['notification-item-text'], 'notification-item-text')}>{text}</p>
        <span className={cn(styles['notification-item-time'], 'notification-item-time')}>
          {moment(activity.time).format('HH:mm')}
        </span>
      </div>
      <span className={cn(styles['notification-item-dot'], 'notification-item-dot')} aria-hidden='true' />
    </div>
  )
}
